import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Tagging } from '@/components/icons/Tagging';
import type { WorkspaceGlobalSearchBarResultTag } from '@/types';
import { cx } from '@trinity/chat-components';
import ClickContainer from './Results.ClickContainer';
import styles from './style/Results.File.module.css';

export default function ResultsTag({ className, index, item, highlighted }: ResultsTagProps) {
  return (
    <ClickContainer index={index} item={item}>
      <div className={cx(styles.root, { [styles.highlighted]: highlighted }, className)}>
        <Tagging
          className={styles.icon}
          size={28} />
        <div className={styles.details}>
          <div className={styles.name}>{item.name}</div>
          <div className={styles.type}>Tag</div>
        </div>
        {highlighted && (
          <div className={styles.return}>
            <KeyboardReturnIcon />
          </div>
        )}
      </div>
    </ClickContainer>
  );
}

export { ResultsTag };

type ResultsTagProps = {
  className?: string;
  index: number;
  item: WorkspaceGlobalSearchBarResultTag;
  highlighted?: boolean;
};